import { ExpressionRuleEditor } from "../Expressions/ExpressionRuleEditor";
import { ExpressionValueRenderer } from "../Builder/ExpressionValueRenderer";
import React from "react";
import { RootExpression } from "../../rule-engine-core/Expressions/RootExpression";

export class RootExpressionEditor extends ExpressionRuleEditor<RootExpression> {
    render() {
        return <ExpressionValueRenderer el={this.ruleData!.expressionRoot!} />;
    }
}
